export const SUBSCRIBE = 'SUBSCRIBE';

export const SUBMIT_CONTACT = 'SUBMIT_CONTACT';
export const POST_PROMO = 'POST_PROMO';
export const GET_QUOTE = 'GET_QUOTE';
export const POST_LOGIN = 'POST_LOGIN';
export const PERSONAL_DATA = 'PERSONAL_DATA';
export const COMPANY_DATA = 'COMPANY_DATA';
export const CHANGE_CONTEXT = 'CHANGE_CONTEXT';
export const SIGNUP_DIALOG = 'SIGNUP_DIALOG';
export const RESTART_STATE = 'RESTART_STATE'
export const POST_RESET_PASSWORD = 'POST_RESET_PASSWORD';
export const POST_CHANGE_PASSWORD = 'POST_CHANGE_PASSWORD';
export const GET_SEARCH = 'GET_SEARCH';
export const POST_COMMENT = 'POST_COMMENT';
export const CHANGE_PLINK_COMPONENT = "CHANGE_PLINK_COMPONENT";
export const GET_VALUES_PLINK = "GET_VALUES_PLINK";
export const CHANGE_PLINK_PERSONAS_COMPONENT = "CHANGE_PLINK_PERSONAS_COMPONENT";
export const GET_BROWSER_AGENT = "GET_BROWSER_AGENT"
export const url = process.env.REACT_APP_URL_BASE 
export const EndPoints = { getJWT: process.env.REACT_APP_GETJWT, crearPagoCheckout: process.env.REACT_APP_CREARPAGOCHECKOUT, crearPagoTdcBoton: process.env.REACT_APP_CREARPAGOTDCBOTON, crearPagoTDDBoton: process.env.REACT_APP_CREARPAGOTDDBOTON, getPlinkUser: process.env.REACT_APP_GET_PLINK_USER, addPlinkUser:process.env.REACT_APP_ENDPOINT_ADDPLINK_USER, crearPagoC2PPlink: process.env.REACT_APP_CREATE_C2PLINK, crearPagoC2PR4: process.env.REACT_APP_CREARPAGOR4C2P }
export const ConstantsCrypto = { MasterKeyCrypto: process.env.REACT_APP_MASTERKEYCRYPTO, MasterKeyCryptoC2P: process.env.REACT_APP_MASTERKEYCRYPTOC2P, JSON_MASTERKEY: process.env.REACT_APP_JSON_MASTERKEY, MasterKeyAddUser: process.env.REACT_APP_MASTER_KEY_ADD_USER }



export const CaptchSiteKey =process.env.REACT_APP_CAPTCHSITEKEY
